import {
  UserCircleIcon,
  UserGroupIcon,
  MusicNoteIcon,
  DocumentTextIcon,
  TicketIcon,
  CalendarIcon,
  PresentationChartBarIcon,
} from "@heroicons/react/outline";

export const serviceKeys = {
  BASE_URL: "https://app.afrodisemusic.com/",
  // BASE_URL: "https://app.afrodisemusic.eu/", 
  API_KEY: "AIzaSyAMadZjBQEFbPk1W_BM-_yMR7boIITzuFw",
};

export const MENU = [
  {
    label: "Bookings Management",
    icon: CalendarIcon,
    path: "/dashboard/bookings",
    permission: "bookings",
  },
  {
    label: "Artists",
    icon: MusicNoteIcon,
    path: "/dashboard/artists",
    permission: "artists",
  },
  {
    label: "Promoters",
    icon: UserGroupIcon,
    path: "/dashboard/promoters",
    permission: "promoters",
  },
  {
    label: "Users & Data",
    icon: UserCircleIcon,
    permission: "users_data",
    children: [
      {
        label: "Users",
        path: "/dashboard/users",
        permission: "users",
      },
      {
        label: "User Types",
        path: "/dashboard/user-types",
        permission: "user_types",
      },
      {
        label: "Companies Info",
        path: "/dashboard/companies",
        permission: "companies_info",
      },
    ],
  },
  {
    label: "Documents",
    icon: DocumentTextIcon,
    path: "/dashboard/documents",
    permission: "documents",
  },
  {
    label: "Ticketing Platform",
    icon: TicketIcon,
    permission: "ticketing",
    children: [
      {
        label: "Events",
        path: "/dashboard/events",
        permission: "events",
      },
      {
        label: "Orders",
        path: "/dashboard/orders",
        permission: "orders",
      },
      {
        label: "Clients",
        path: "/dashboard/clients",
        permission: "clients",
      },
      {
        label: "Sales Tags",
        path: "/dashboard/sales-tags",
        permission: "sales_tags",
      },
    ],
  },
  {
    label: "Marketing",
    icon: PresentationChartBarIcon,
    permission: "marketing",
    children: [
      {
        label: "Landing Pages",
        path: "/dashboard/landing-pages",
        permission: "landing_pages",
      },
      {
        label: "Shorten Links & QRs",
        path: "/dashboard/shorten-links",
        permission: "links",
      },
      {
        label: "Pixels",
        path: "/dashboard/pixels",
        permission: "pixels",
      },
    ],
  },
];

export const BOOKING_STATUS = {
  booking_requested: {
    label: "Booking Requested",
    color: "text-yellow-400",
  },
  awaiting_artist_approval: {
    label: "Awaiting Artist Approval",
    color: "text-orange-400",
  },
  contracts_and_invoices_sent: {
    label: "Contracts Sent",
    color: "text-blue-400",
  },
  partial_payment_received: {
    label: "Partial Payment Received",
    color: "text-blue-600",
  },
  gig_completed: {
    label: "Gig Completed",
    color: "text-green-900",
  },
  payment_received: {
    label: "Payment Received",
    color: "text-green-400",
  },
};

export const CALENDAR_STATUS = {
  booking_requested: "bg-yellow-400",
  awaiting_artist_approval: "bg-orange-400",
  contracts_and_invoices_sent: "bg-blue-400",
  partial_payment_received: "bg-gradient-to-r from-green-500 to-blue-500",
  payment_received: "bg-green-400",
  gig_completed: "bg-green-900",
};

export const CALENDAR_STATUS_PRIORITY = [
  "booking_requested",
  "awaiting_artist_approval",
  "contracts_and_invoices_sent",
  "partial_payment_received",
  "payment_received",
  "gig_completed",
];

export const ARTIST_TECH_SECTIONS = {
  technical: {
    title: "Edit Technical Info",
    fields: [
      { key: "dj_booth", label: "DJ Booth" },
      { key: "no_of_players", label: "No of Players" },
      { key: "type_of_players", label: "Type of Players" },
      { key: "mixer_type", label: "Mixer Type" },
      { key: "monitor_tops_info", label: "Monitor Tops Info" },
      { key: "monitor_subs_info", label: "Monitor Subs Info" },
      { key: "other_technical_info", label: "Other Technical Info" },
    ],
    documentKey: "technical_document_pdf",
  },

  hospitality: {
    title: "Edit Hospitality Info",
    fields: [
      {
        key: "hotel_rating_required",
        label: "Hotel Rating Required",
        type: "rating",
        max: 7,
      },
      { key: "hotel_hospitality", label: "Hotel Hospitality" },
      { key: "dj_booth_hospitality", label: "DJ Booth Hospitality" },
      { key: "dj_booth_access", label: "DJ Booth Access" },
      { key: "dj_booth_security", label: "DJ Booth Security" },
      { key: "guest_list_requirements", label: "Guest List Requirements" },
    ],
    documentKey: "hospitality_document_pdf",
  },

  transfers: {
    title: "Edit Transfers Info",
    fields: [
      { key: "is_car_required", label: "Car / Van Required", type: "boolean" },
      { key: "no_of_people", label: "No of People" },
      { key: "accepted_car_models", label: "Accepted Car Models" },
      { key: "special_car_requirements", label: "Special Car Requirements" },
    ],
  },
};

export const DOCUMENT_TYPES = [
  { label: "Contract", value: "contract" },
  { label: "Invoice", value: "invoice" },
  { label: "OTHER", value: "other" },
];

export const CURRENCIES = ["USD", "GBP", "EUR"];

export const CURRENCY_MAP = {
  GBP: "£",
  USD: "$",
  RON: "lei",
  EUR: "€",
  AED: "د.إ",
};
